module.exports = __webpack_public_path__ + "img/big-safe-box.e23f1adc.svg";